/**
 * utils to get data from prismic documents
 */

const PRISMIC_KITTL_CDN = 'https://cdnp.kittl.com';

export const getMediaCdnUrl = (imageUrl) => {
  if (imageUrl?.includes('.gif')) {
    // prismic compresses gif files with `,format` to a format that
    // firefox can't load
    imageUrl = imageUrl.replace(',format', '');
  }

  imageUrl = imageUrl?.replace(
    'https://images.prismic.io/kittlblog',
    PRISMIC_KITTL_CDN
  );
  imageUrl = imageUrl?.replace(
    'https://kittlblog.cdn.prismic.io/kittlblog',
    PRISMIC_KITTL_CDN
  );

  return imageUrl;
};

export const getPreview = (data) => {
  if (data?.coverImage?.url) {
    return getMediaCdnUrl(data.coverImage.url);
  }
  const image = data?.slices.find((slice) => slice.slice_type === 'image');
  if (!image) {
    return null;
  }

  if (image.primary.image) {
    return getMediaCdnUrl(image.primary.image.url);
  }
  if (image.items?.length) {
    if (image.items[0]?.image?.url) {
      return getMediaCdnUrl(image.items[0].image.url);
    }
  }
  return null;
};

export const getPreviewText = (data) => {
  const text = data?.slices
    .find((slice) => slice.slice_type === 'text')
    ?.primary.text.find((item) => item.type === 'paragraph');

  if (!text) {
    return null;
  }

  if (text.text.length > 100) {
    return `${text.text.substring(0, 100)}...`;
  }
  return text.text;
};
